import {pricesAPI} from "../../API/API";
import {SET_PRICE_PRECENT, SET_RATE_PLAN, SET_SALES_ACTIVE} from "./constans";
import {getRoomsList} from "../../globalState/object/actions";
import {updateSavingStatus} from "../../globalState/app/actions";


export const setPrice = (payload) => {
    return {
        type: SET_PRICE_PRECENT,
        payload
    }
};

export const setRatePlan = (payload) => {
    return {
        type: SET_RATE_PLAN,
        payload
    }
};


export const setSalesActive = (payload) => {
    return {
        type: SET_SALES_ACTIVE,
        payload
    }
}



export const getPrices = (formData) => async (dispatch) => {
    let response = await pricesAPI.getCommissionList(formData);

    if (response.status) {
        return dispatch(updaterPrices(response))

    }
}

export const updateRatePlan = (ratePlan) => (dispatch) => {
    dispatch(setRatePlan(ratePlan))
}



export const updatePrices = (prices) => async (dispatch) => {
    dispatch(updateSavingStatus({status: "loading"}))
    let response = await pricesAPI.updateCommission(prices);

    if (response.status) {
        dispatch(updateSavingStatus({status: "success"}))
         dispatch(getRoomsList({object: prices.object}))
         dispatch(updaterPrices(response))
        return true
    } else {
        dispatch(updateSavingStatus({status: "error", message: response.data.message}))
    }
}

export const updateSalesActive = (prices) => async (dispatch) => {
    dispatch(updateSavingStatus({status: "loading"}))
    let response = await pricesAPI.updateSalesActive(prices)

    if (response.status) {
        dispatch(updateSavingStatus({status: "success"}))
        dispatch(setSalesActive(response.data))
        return true
    } else {
        dispatch(updateSavingStatus({status: "error", message: response.data.message}))
    }
}


export const updaterPrices = (response) => async (dispatch) => {
    let data = response.data
    let prices = response.data.prices
    let priceType = response.data.priceType

    let today = new Date()
    let thisYear = today.getFullYear()
    let thisMonth = today.getMonth()

    let newPrices = {}
    for (let i = 0; i <= 23; i++) {
        let month = new Date(thisYear, thisMonth + i)
        let lastDayOfMonth = new Date(thisYear, thisMonth+i+1, 0).getDate()

        for (let k = 1; k <= lastDayOfMonth; k++) {
            let newDate = new Date(month.getFullYear(), month.getMonth(), k).toLocaleDateString('ru-RU').split(".").reverse().join("-")

            let disabled = new Date(newDate).getTime() + 86400000 < today.getTime()

            if (prices.hasOwnProperty(newDate)) {
                newPrices = {...newPrices, [newDate]: {...prices[newDate], disabled: disabled}}
            } else {
                newPrices = {...newPrices, [newDate]: {price: [{type: data.maxType}], disabled: disabled}}
            }
        }
    }

    data = {...data, prices: newPrices}

    return dispatch(setPrice(data))
}




